[
  {
    "code": "DE-BW",
    "name": "Baden-Württemberg"
  },
  {
    "code": "DE-BY",
    "name": "Bayern"
  },
  {
    "code": "DE-BE",
    "name": "Berlin"
  },
  {
    "code": "DE-BB",
    "name": "Brandenburg"
  },
  {
    "code": "DE-HB",
    "name": "Bremen"
  },
  {
    "code": "DE-HH",
    "name": "Hamburg"
  },
  {
    "code": "DE-HE",
    "name": "Hessen"
  },
  {
    "code": "DE-MV",
    "name": "Mecklenburg-Vorpommern"
  },
  {
    "code": "DE-NI",
    "name": "Niedersachsen"
  },
  {
    "code": "DE-NW",
    "name": "Nordrhein-Westfalen"
  },
  {
    "code": "DE-RP",
    "name": "Rheinland-Pfalz"
  },
  {
    "code": "DE-SL",
    "name": "Saarland"
  },
  {
    "code": "DE-SN",
    "name": "Sachsen"
  },
  {
    "code": "DE-ST",
    "name": "Sachsen-Anhalt"
  },
  {
    "code": "DE-SH",
    "name": "Schleswig-Holstein"
  },
  {
    "code": "DE-TH",
    "name": "Thüringen"
  }
]